export default "__VITE_ASSET__B1EBnwp4__"